<template>
  <a-input
    class="search-input"
    :placeholder="placeholder"
    v-model:value="searchString"
    @keyup.enter="runSearching"
    @change="() => emit('update', searchString)"
  />
</template>

<script setup>
  import { onMounted, ref, watch } from 'vue';
  import { useRoute, useRouter } from 'vue-router';

  const emit = defineEmits(['update']);
  const route = useRoute();
  const router = useRouter();

  let searchString = ref('');

  const props = defineProps({
    placeholder: {
      type: String,
      default: 'Поиск...',
    },
    pageName: {
      type: String,
      required: true,
    },
    hash: {
      type: String,
      default: '#all',
    },
    searchString: {
      type: String,
    },
  });

  const runSearching = () => {
    if (searchString.value) {
      router.push({
        name: props.pageName,
        query: {
          ...route.query,
          textSearch: searchString.value,
        },
        hash: props.hash,
      });
    } else {
      router.push({
        name: props.pageName,
        hash: props.hash,
      });
    }
  };

  onMounted(() => {
    searchString.value = route.query.textSearch ?? '';
  });

  watch(
    () => props.searchString,
    () => {
      searchString.value = props.searchString;
    }
  );
</script>

<style lang="scss" scoped>
  .search-input {
    background: url('../assets/search.svg') no-repeat right 8px center #fff;
    padding-right: 40px;
    width: 100%;

    &.dark {
      background-color: #383d4f;
      border-color: #383d4f;
      color: #babbc2;

      &::placeholder {
        color: #babbc2;
      }
    }
  }
</style>
